/* Gift guard (Novitheric) â€” keeps free-gift lines honest on every cart change.
   1) Removes any line with _is_free_gift=true whose _linked_to_product parent
      (matched by product_id OR variant_id) is no longer a paid line in the cart.
   2) Clamps each gift variant to ONE unit per parent (merges duplicate lines).
   Client-side only; a determined user can still bypass it (see report). */
(function () {
  'use strict';
  if (window.__nvGiftGuard) return;
  window.__nvGiftGuard = true;

  var MAX_PER_GIFT = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var busy = false, again = false, timer = null;
  var nativeFetch = window.fetch.bind(window);

  function isGift(it) { return it.properties && String(it.properties._is_free_gift) === 'true'; }

  function plan(cart) {
    var paid = cart.items.filter(function (it) { return !isGift(it); });
    var updates = {}, seen = {}, n = 0;
    cart.items.forEach(function (it) {
      if (!isGift(it)) return;
      var link = String(it.properties._linked_to_product || '');
      var hasParent = link && paid.some(function (p) {
        return String(p.product_id) === link || String(p.variant_id) === link;
      });
      var k = link + ':' + it.variant_id;
      var allowed = hasParent ? Math.max(0, MAX_PER_GIFT - (seen[k] || 0)) : 0;
      var want = Math.min(it.quantity, allowed);
      seen[k] = (seen[k] || 0) + want;
      if (want !== it.quantity) { updates[it.key] = want; n++; }
    });
    return n ? updates : null;
  }

  function refreshUI(state) {
    try {
      var html = state && state.sections && state.sections['cart-drawer'];
      var oldCart = document.querySelector('cart-drawer');
      if (html && oldCart && typeof window.updateCartDrawer === 'function') {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        if (fresh) { window.updateCartDrawer(oldCart, fresh, false, null); return; }
      }
      if (html && oldCart) {
        var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var cur = oldCart.querySelector('#CartDrawer');
        if (inner && cur) { cur.innerHTML = inner.innerHTML; return; }
      }
      if (/\/cart\/?$/.test(location.pathname)) location.reload();
    } catch (e) { if (/\/cart\/?$/.test(location.pathname)) location.reload(); }
  }

  function run() {
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = plan(cart);
        if (!updates) return null;
        var body = { updates: updates };
        if (document.querySelector('cart-drawer')) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname; }
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(refreshUI);
      })
      .catch(function (e) { console.warn('[gift-guard]', e); })
      .then(function () { busy = false; if (again) { again = false; schedule(); } });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(run, 400); }

  // Watch every cart mutation made through fetch (theme, apps, upsell blocks).
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(url)) p.then(schedule, schedule);
    } catch (e) {}
    return p;
  };
  // ...and through XHR (older app scripts).
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    try { if (CART_RE.test(String(url))) this.addEventListener('loadend', schedule); } catch (e) {}
    return xo.apply(this, arguments);
  };
  if (window.subscribe && window.PUB_SUB_EVENTS) { try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule); } catch (e) {} }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.nvGiftGuardRun = run;
})();